module.exports = __webpack_public_path__ + "img/broom.036d7259.svg";